import { Canvas } from '@react-three/fiber';
import * as THREE from 'three';
import { Scene } from './scene/Scene';
import { Hud } from './hud/Hud';
import { RealtimeProvider } from './net/RealtimeProvider';
import { camera, palette } from './theme/tokens';

/**
 * App root: the R3F <Canvas> (the 3D casino) + the DOM HUD overlay as a SIBLING
 * (CLAUDE.md / ARCHITECTURE.md §2.2), both inside the realtime provider so HUD
 * widgets can send intents and the store stays fed by server messages.
 *
 * MSAA (`antialias`) is OFF because we run an EffectComposer (selective bloom);
 * dpr is capped to 1.5 to keep the per-client GPU budget sane.
 *
 * EXPOSURE/BACKGROUND: the scene must read as a DARK, warmly-lit casino at night.
 * Tone mapping + low exposure are set ON THE `gl` PROP (not `onCreated`, not a
 * useEffect) — R3F owns and re-applies `gl` props, so this value sticks across
 * re-renders AND HMR. The near-black warm background is a reactive <color> node.
 * The HDRI is reflections-only; the warm lights pool on the felt (see Lighting.tsx).
 */
export function App() {
  return (
    <RealtimeProvider>
      <Canvas
        dpr={[1, 1.5]}
        shadows
        gl={{
          antialias: false,
          toneMapping: THREE.ACESFilmicToneMapping,
          toneMappingExposure: 0.62, // pull the whole scene down — moody casino
        }}
        camera={{ position: [...camera.position], fov: camera.fov }}
      >
        {/* Reactive near-black warm background — survives HMR. */}
        <color attach="background" args={[palette.backdrop]} />
        <Scene />
      </Canvas>

      {/* DOM HUD overlay — sibling of <Canvas>, pointer-events discipline in CSS. */}
      <Hud />
    </RealtimeProvider>
  );
}
